/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import ErrorDialog from 'Common/Components/ErrorDialog';
import { getCustomAttributes } from 'store/CustomAttributes/actions';
import {
  removeComment,
  resetErrorValue,
  showManageLeftFilters,
  hideVulnerabilityDetail,
  loadVulnerabilityDetail,
  unSelectAll
} from 'store/Manage/actions';
import {
  selectSelectedComment,
  selectError,
  selectErrorMessage,
  selectShowDetail,
  selectShowQuickPlanner
} from 'store/Manage/selectors';
import {
  clearAdvancedFilter,
  getCustomFilters,
  resetFilters
} from 'store/Filters/actions';
import { getSelectedEntity } from 'store/Filters/selectors';
import { selectShowHostLeftFilters } from 'store/Host/selectors';
import { useSelector, useDispatch } from 'react-redux';
import {
  hideHostDetail,
  hideServiceDetail,
  resetServiceDetail,
  updateService,
  loadServiceDetail,
  addServiceTag,
  removeServiceTag,
  setServicesTags
} from 'store/Contextualization/AssetDetail/actions';
import {
  selectShowHostDetail,
  selectShowDetail as selectAssetShowDetail,
  selectDetail as selectAssetDetail,
  selectServiceId,
  selectServiceOwned,
  selectServiceDescription,
  selectSelected as selectAssetSelected,
  selectDetailTags as selectAssetDetailTags,
  selectHostDetailTags
} from 'store/Contextualization/AssetDetail/selectors';
import {
  getTags,
  getHostsTags,
  getServicesTags
} from 'Screens/Contextualization/Tags/actions/Actions';
import get from 'lodash/get';
import ConfirmationDialog from 'Common/Components/ConfirmationDialog';
import ReduxModal from 'Common/Components/ReduxModal';
import {
  MODAL_UPGRADE_LICENSE,
  MODAL_MOVE_VULN_HOST,
  MODAL_CANT_CREATE
} from 'store/modals/modals';
import { closeModal } from 'store/modals/actions';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import upgradeLicenseImage from 'Images/workspaces-license.png';
import { ACTIONS } from 'tracking/GA/constants';
import selectModal from 'store/modals/selectors';
import { selectCurrentWorkspace, selectIsReadOnly } from 'store/Faraday/selectors';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';
import CustomDragLayer from 'Common/Components/DragAndDrop/CustomDragLayer';
import { Wrapper, TableContainer } from './styled';
import 'Common/styles/markdownStyles.scss';
import ManageTable from './components/ManageTable';
import VulnerabilityDetail from './components/VulnerabilityDetail';
import HostDetail from 'Screens/Contextualization/Host/components/HostDetail';
import ServiceDetail from 'Screens/Contextualization/Services/components/ServiceDetail';
import CustomActionBar from './components/CustomActionBar';
import FilterSideBar from './components/FilterSideBar';
import TemplateModal from './components/ManageTable/components/ContextMenu/components/TemplateModal';
import 'Screens/Contextualization/Manage/styles/manageStyles.scss';
import { removeCurrentHost } from 'store/Host/actions';
import { VulnsTour } from 'Common/Components/Tour';
import { MoveVulnModal } from './components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/HostData';
import {
  getHostsCountInWs,
  getVulnsCountInWs
} from 'Screens/Contextualization/Faraday/actions/Actions';
import WarningModal from 'Screens/Contextualization/ManageEditCreate/components/WarningModal';
import CreateEditModal from 'Screens/Credentials/components/CreateEditModal';
import { selectShowCreateEditModal } from 'store/Credentials/selectors';
import ImportCredentialModal from 'Screens/Credentials/components/ImportCredentialModal';
import ExploreGroupBar from './components/ExploreGroupBar';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_BULK_CREATE, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import useReportFileDrop from 'Hooks/useReportFileDrop';
import ReportFileDropOverlay from 'Common/Components/ReportFileDropOverlay';

const ManageContext = ({ params }) => {
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const errorMessage = useSelector(selectErrorMessage);
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const selectedEntity = useSelector(getSelectedEntity);
  const showHostFilters = useSelector(selectShowHostLeftFilters);
  const showCommentDeletionModal = useSelector((state) =>
    selectModal(state, 'commentDeletion')
  );
  const showModal = useSelector((state) =>
    selectModal(state, MODAL_UPGRADE_LICENSE)
  );
  const selectedComment = useSelector((state) => selectSelectedComment(state));
  const showDetail = useSelector(selectShowDetail);
  const showMoveVulnModal = useSelector((state) => selectModal(state, MODAL_MOVE_VULN_HOST));
  const showModalCantCreate = useSelector((state) => selectModal(state, MODAL_CANT_CREATE));
  const showCreateEditModalCredentials = useSelector(selectShowCreateEditModal);
  const showHostDetail = useSelector(selectShowHostDetail);
  const showServiceDetail = useSelector((state) => selectAssetShowDetail('services', state));
  const serviceDetailData = useSelector((state) => selectAssetDetail('services', state));
  const serviceId = useSelector(selectServiceId);
  const serviceOwned = useSelector(selectServiceOwned);
  const serviceDescription = useSelector(selectServiceDescription);
  const servicesSelected = useSelector((state) => selectAssetSelected('services', state));
  const serviceDetailTags = useSelector((state) => selectAssetDetailTags('services', state));
  const hostDetailTags = useSelector(selectHostDetailTags);
  const readOnly = useSelector(selectIsReadOnly);
  const importVulnsAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_BULK_CREATE, PERMISSION_TYPES.CREATE));
  const showQuickPlanner = useSelector(selectShowQuickPlanner);
  const [showModalUploadVulns, setShowModalUploadVulns] = useState(false);
  const [filesToImport, setFilesToImport] = useState([]);

  const handleDropReportFiles = useCallback((files) => {
    setFilesToImport(files);
    setShowModalUploadVulns(true);
  }, []);

  const handleCloseImportModal = useCallback(() => {
    setFilesToImport([]);
    setShowModalUploadVulns(false);
  }, []);

  const { isDraggingFiles, dropHandlers } = useReportFileDrop({
    disabled: !workspaceSelected || readOnly || !importVulnsAllowedByRole || showModalUploadVulns || showQuickPlanner,
    onDrop: handleDropReportFiles
  });

  const handleParamId = useCallback(() => {
    const id = get(params, 'id', 0);
    if (parseInt(id, 10) > 0) dispatch(loadVulnerabilityDetail(id, true));
    else dispatch(hideVulnerabilityDetail());
  }, [params]);

  useEffect(() => {
    dispatch(getCustomAttributes());
    dispatch(getCustomFilters());
    if (showHostFilters) dispatch(showManageLeftFilters(true));
    else dispatch(showManageLeftFilters(false));
  }, [showHostFilters, selectedEntity, dispatch]);

  useEffect(() => {
    handleParamId();
  }, [handleParamId]);

  useEffect(() => {
    dispatch(getTags());
    dispatch(getHostsTags());
    dispatch(getServicesTags());
    dispatch(getVulnsCountInWs());
    dispatch(getHostsCountInWs());
  }, [dispatch, workspaceSelected]);

  useEffect(
    () => () => {
      dispatch(resetFilters('vulns'));
      dispatch(clearAdvancedFilter('vulns'));
      dispatch(closeModal(MODAL_CANT_CREATE));
      dispatch(hideVulnerabilityDetail());
      dispatch(hideHostDetail());
      dispatch(hideServiceDetail());
      dispatch(unSelectAll());
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(removeCurrentHost());
  }, [dispatch]);

  return (
    <Wrapper { ...dropHandlers }>
      {isDraggingFiles && <ReportFileDropOverlay />}
      <ExploreGroupBar />
      <CustomActionBar />
      <TableContainer>
        <CustomDragLayer />
        <ManageTable />
        <FilterSideBar entity="vulns" />
        {showDetail && <VulnerabilityDetail />}
        {showHostDetail && <HostDetail hostTags={ hostDetailTags } onClose={ () => dispatch(hideHostDetail()) } />}
        {showServiceDetail && (
          <ServiceDetail
            data={ serviceDetailData }
            resetServiceDetail={ resetServiceDetail }
            serviceId={ serviceId }
            owned={ serviceOwned }
            updateService={ (id, obj) => dispatch(updateService(id, obj)) }
            redirectToService={ hideServiceDetail }
            loadServiceDetail={ loadServiceDetail }
            description={ serviceDescription }
            entity="serviceAssetDetail"
            serviceTags={ serviceDetailTags }
            servicesSelected={ servicesSelected }
            addTag={ addServiceTag }
            removeTag={ removeServiceTag }
            setServicesTags={ setServicesTags }
          />
        )}
        <EEFeatureSlot featureKey="quick-planner" />
        <TemplateModal />
      </TableContainer>
      {error
        ? (
        <ErrorDialog
          message={ errorMessage }
          resetError={ () => dispatch(resetErrorValue()) }
        />
          )
        : null}
      {showModal && (
        <ReduxModal id={ MODAL_UPGRADE_LICENSE }>
          <UpgradeLicense
            id={ MODAL_UPGRADE_LICENSE }
            image={ upgradeLicenseImage }
            descriptionIntlId="upgradeLicense.workspace.description"
            trackingShow={ ACTIONS.showVulns }
            trackingClick={ ACTIONS.clickVulns }
          />
        </ReduxModal>
      )}
      <ConfirmationDialog
        show={ showCommentDeletionModal }
        title="Delete Comment"
        submitText="Delete"
        message="A comment will be deleted. This action cannot be undone. Are you sure you want to proceed?"
        handleClose={ () => dispatch(closeModal('commentDeletion')) }
        handleSubmit={ () => {
          dispatch(removeComment(selectedComment.id));
          dispatch(closeModal('commentDeletion'));
        } }
      />
      <VulnsTour />
      {showMoveVulnModal && <MoveVulnModal />}
      {showModalCantCreate && <WarningModal entity="Vulnerability" />}
      {showCreateEditModalCredentials && <CreateEditModal isVulnDetail />}
      <ImportCredentialModal isVulnDetail />
      {showModalUploadVulns && <ImportFileCreationModal handleClose={ handleCloseImportModal } initialFiles={ filesToImport } />}
    </Wrapper>
  );
};

ManageContext.propTypes = {
  params: PropTypes.object.isRequired
};

export default ManageContext;
